module.exports = __webpack_public_path__ + "media/icons/lock-ee91938d.svg";